import React, { useEffect, useState } from "react";
import MyContext from "./MyContext";

const MyProvider = ({ children }) => {
  // ── Existing blog/ticket state ──
  const [posts, setPosts] = useState([]);
  const [allMessages, setAllMessages] = useState([]);
  const [category, setCategory] = useState(null);
  const [filterPosts, setFilterPosts] = useState([]);
  const [uniqueCategory, setUniqueCategory] = useState(new Set());

  // ── NEW: Authentication state ──
  const [user, setUser] = useState(null);

  // Load user once on app start
  useEffect(() => {
    const stored = sessionStorage.getItem("User");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed);
      } catch (err) {
        console.error("Invalid user in sessionStorage", err);
        sessionStorage.removeItem("User");
      }
    }
  }, []); // ← only once on mount

  // Optional: helper functions (cleaner API)
  const login = (userData) => {
    sessionStorage.setItem("User", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    sessionStorage.removeItem("User");
    setUser(null);
  };

  // ── Your existing fetches ──
  const Getallposts = async () => {
    try {
      const res = await fetch("https://technic-mentors-backend.vercel.app/api/auth/getallposts");
      const data = await res.json();
      setPosts(data);
      const newCategory = new Set(data.map((post) => post.category));
      setUniqueCategory(newCategory);
      if (newCategory.size > 0 && !category) {
        setCategory([...newCategory][0]);
      }
    } catch (err) {
      console.error("Failed to load posts", err);
    }
  };

  const ticketMessages = async () => {
    try {
      const res = await fetch("https://technic-mentors-backend.vercel.app/api/auth/messages", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      setAllMessages(data);
    } catch (err) {
      console.error("Failed to load messages", err);
    }
  };

  useEffect(() => {
    Getallposts();
    ticketMessages();
  }, []);

  useEffect(() => {
    if (!category) {
      setFilterPosts([]);
    } else {
      const filtered = posts.filter((post) => post.category === category);
      setFilterPosts(filtered);
    }
  }, [category, posts]);

  return (
    <MyContext.Provider
      value={{
        // blog/tickets
        filterPosts,
        posts,
        uniqueCategory,
        setCategory,
        allMessages,
        ticketMessages,
        // ── NEW auth values ──
        user,
        login,
        logout,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyProvider;